import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { church } from '../../mock/data';
import { mapsDirectionsUrl, fullAddress } from '../../lib/utils';

function pinIcon(color) {
  return L.divIcon({
    className: '',
    html: `<div style="width:26px;height:26px;transform:translate(-50%,-100%);">
      <div style="width:22px;height:22px;background:${color};border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);margin:0 auto;box-shadow:0 2px 6px rgba(15,23,42,0.35);"></div>
    </div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 26],
  });
}

const meIcon = L.divIcon({
  className: '',
  html: `<div style="width:20px;height:20px;transform:translate(-50%,-50%);">
    <div style="width:16px;height:16px;background:#0284c7;border:3px solid #fff;border-radius:50%;box-shadow:0 0 0 6px rgba(2,132,199,0.25);"></div>
  </div>`,
  iconSize: [20, 20],
  iconAnchor: [10, 10],
});

export default function MapView({ items, origin, radiusKm }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current) return;
    const map = L.map(containerRef.current, {
      center: [church.center.lat, church.center.lng],
      zoom: 13,
      zoomControl: true,
      scrollWheelZoom: false,
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap',
      maxZoom: 19,
    }).addTo(map);
    layerRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    setTimeout(() => map.invalidateSize(), 200);
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();

    const bounds = [];

    items.forEach(({ cell, network }) => {
      const { lat, lng } = cell.address;
      const marker = L.marker([lat, lng], { icon: pinIcon(network?.color || '#0284c7') });
      marker.bindPopup(
        `<div style="font-family:'DM Sans',sans-serif;min-width:180px">
          <strong style="font-family:Manrope;font-size:14px;color:#0f172a">${cell.name}</strong>
          <div style="font-size:12px;color:#475569;margin-top:2px">${network?.name || ''}</div>
          <div style="font-size:12px;color:#475569;margin-top:4px">${cell.day} · ${cell.time}</div>
          <div style="font-size:12px;color:#94a3b8;margin-top:2px">${fullAddress(cell.address)}</div>
          <a href="${mapsDirectionsUrl(cell.address)}" target="_blank" rel="noreferrer"
             style="display:inline-block;margin-top:8px;background:#0284c7;color:#fff;font-family:Manrope;font-weight:600;font-size:12px;padding:6px 12px;border-radius:9999px;text-decoration:none">Como chegar</a>
        </div>`
      );
      marker.addTo(layer);
      bounds.push([lat, lng]);
    });

    if (origin) {
      L.marker([origin.lat, origin.lng], { icon: meIcon }).addTo(layer).bindPopup('Você está aqui');
      if (radiusKm) {
        L.circle([origin.lat, origin.lng], {
          radius: radiusKm * 1000,
          color: '#0284c7',
          weight: 1.5,
          fillColor: '#0284c7',
          fillOpacity: 0.08,
        }).addTo(layer);
      }
      bounds.push([origin.lat, origin.lng]);
    }

    if (bounds.length > 0) {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
    }
  }, [items, origin, radiusKm]);

  return (
    <div
      ref={containerRef}
      data-testid="cells-map"
      className="h-[460px] w-full overflow-hidden rounded-2xl border border-slate-200 shadow-soft md:h-[560px]"
      style={{ zIndex: 0 }}
    />
  );

}
